import { ANIMATIONS, BORDERS } from '../app.config';
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class Cursor {

  constructor(context, scroller) {
    this.context = context;
    this.e;
    this.t = [
      "scroll",
      "wheel",
      "touchstart",
      "touchmove",
      "touchenter",
      "touchend",
      "touchleave",
      "mouseout",
      "mouseleave",
      "mouseup",
      "mousedown",
      "mousemove",
      "mouseenter",
      "mousewheel",
      "mouseover"
    ];
    this.lenis = scroller;
    this.pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    this.mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    this.active = false;
    this.cursor = document.querySelector('#cursor');

    this.init();
  }

  init() {
    gsap.to(this.cursor, 0, { scale: 0 });
    this.initCursor();
  }

  initCursor() {
    let speed = 0.18,
      xSet,
      ySet,
      ratio;
    window.addEventListener("mousemove", (e) => {
      this.mouse.x = e.x;
      this.mouse.y = e.y;
    });
    gsap.set(this.cursor, { xPercent: -50, yPercent: -50 });
    xSet = gsap.quickSetter(this.cursor, "x", "px");
    ySet = gsap.quickSetter(this.cursor, "y", "px");

    gsap.ticker.add( () => {
      if (!this.active) {
        ratio = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());
        this.pos.x += (this.mouse.x - this.pos.x) * ratio;
        this.pos.y += (this.mouse.y - this.pos.y) * ratio;
        xSet(this.pos.x);
        ySet(this.pos.y);
      }
    });
  }

  static initMagnetItems(context) {
    const magnets = new MagnetItems(context);
    return magnets
  }

  static initAnchors(context) {
    const anchors = new AnchorItems(context);
    return anchors;
  }

  static init(context) {
    Cursor.anchors = !document.body.classList.contains('mobile') && Cursor.initAnchors(context);
    Cursor.magnets = Cursor.initMagnetItems(context);
    return Cursor;
  }

  static destroyAll() {
    if (Cursor.anchors.length !== 0 && Cursor.anchors) {
      Cursor.anchors.destroyAll();
      Cursor.anchors = [];
    }

    if (Cursor.magnets.length !== 0 && Cursor.magnets) {
      Cursor.magnets.destroyAll();
      Cursor.magnets = [];
    }
  }
}

export class AnchorItems {

  constructor(node) {
    this.node = node;
    this.cursor = document.querySelector('#cursor');
    this.anchors = Array.from(node.querySelectorAll('[data-zoom-button]'));
    this.addEventListener();
  }

  addEventListener() {
    this.onMouseEnterHandler = this.onMouseEnter.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeave.bind(this);

    this.anchors.forEach((anchor) => {
      anchor.addEventListener('mouseenter', this.onMouseEnterHandler);
      anchor.addEventListener('mouseleave', this.onMouseLeaveHandler);
    });
  }

  onMouseEnter(e) {
    const anchor = e.currentTarget;
    document.body.classList.add('_hidden-cursor');
    gsap.to(this.cursor, 0.25, { scale: 1 });
    const className = anchor.dataset.zoomButton === 'link' ? '_link-hover' : '_expand-hover';
    this.cursor.classList.add(className);
    if (e.cancelable) e.preventDefault();
  }

  onMouseLeave(e) {
    const anchor = e.currentTarget;
    document.body.classList.remove('_hidden-cursor');
    const className = anchor.dataset.zoomButton === 'link' ? '_link-hover' : '_expand-hover';
    gsap.to(this.cursor, 0.25, { scale: 0 });
    this.cursor.classList.remove(className);
    if (e.cancelable) e.preventDefault();
  }

  destroyAll() {
    this.anchors.forEach((anchor) => {
      anchor.removeEventListener('mouseenter', this.onMouseEnterHandler);
      anchor.removeEventListener('mouseleave', this.onMouseLeaveHandler);
    });

    gsap.to(this.cursor, 0.25, { scale: 0, onComplete: () => {
      this.cursor.classList.remove('_link-hover');
      this.cursor.classList.remove('_expand-hover')
    } });
  }
}

export class MagnetItems {

  constructor(node) {
    this.node = node;
    this.cursor = document.querySelector('#cursor');
    this.magneticElement = Array.from(node.querySelectorAll('[data-magnet-btn] .cta__item'));
    this.addEventListener();
  }

  addEventListener() {
    this.onMouseEnterHandler = this.onMouseEnter.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeave.bind(this);

    this.magneticElement.forEach((element) => {
      element.addEventListener('mouseenter', this.onMouseEnterHandler);
      element.addEventListener('mouseleave', this.onMouseLeaveHandler);
      element.addEventListener("touchstart", this.onMouseEnterHandler);
      element.addEventListener("touchend", this.onMouseLeaveHandler);
    });
  }

  onMouseEnter(e) {
    const element = e.currentTarget;
    let coordinates = {x: 0, y: 0};
    const isTouch = e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel';
    const isMouse = e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover'|| e.type=='mouseout' || e.type=='mouseenter' || e.type=='mouseleave'

    if(isTouch){
      var touch = e.touches[0] || e.changedTouches[0];
      coordinates.x = touch.pageX;
      coordinates.y = 0;
    } else if (isMouse) {
      coordinates.x = e.clientX;
      coordinates.y = e.clientY;
    }

    let boundingRect = element.getBoundingClientRect(),
    size = boundingRect.width * 2.25,
    relX = coordinates.x - boundingRect.left,
    relY = coordinates.y !== 0 ? coordinates.y - boundingRect.top : boundingRect.height / 2;

    const btn = element.querySelector('.btn__hover');
    const btnStyle = `top: ${relY}px; left: ${relX}px; width: ${size}px; height: ${size}px;`;
    element.classList.add('_hover');
    btn.style.cssText = btnStyle;
    this.active = true;

    if (isTouch) {
      const buttonEl = element.querySelector('.btn')
      buttonEl.focus();
      buttonEl.tabIndex = '-1';
    } else {
      if (e.cancelable) e.preventDefault();
    }
  }

  onMouseLeave(e) {
    const element = e.currentTarget;
    let coordinates = {x: 0, y: 0};
    const isTouch = e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel';
    const isMouse = e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover'|| e.type=='mouseout' || e.type=='mouseenter' || e.type=='mouseleave'
    if(isTouch){
      var touch = e.touches[0] || e.changedTouches[0];
      coordinates.x = touch.pageX;
      coordinates.y = 0;
    } else if (isMouse) {
      coordinates.x = e.clientX;
      coordinates.y = e.clientY;
    }

    let boundingRect = element.getBoundingClientRect(),
    relX = coordinates.x - boundingRect.left,
    relY = coordinates.y !== 0 ? coordinates.y - boundingRect.top : boundingRect.height / 2;

    const btn = element.querySelector('.btn__hover');
    const btnStyle = `top: ${relY}px; left: ${relX}px; width: 0px; height: 0px;`;
    element.classList.remove('_hover');
    btn.style.cssText = btnStyle;

    cursor.classList.add("_visible");
    this.active = false;

    if (isTouch) {
      const buttonEl = element.querySelector('.btn')
      buttonEl.blur();
    } else {
      if (e.cancelable) e.preventDefault();
    }
  }


  destroyAll() {
    this.magneticElement.forEach((element) => {
      element.removeEventListener('mouseenter', this.onMouseEnterHandler);
      element.removeEventListener('mouseleave', this.onMouseLeaveHandler);
      element.removeEventListener("touchstart", this.onMouseEnterHandler);
      // element.removeEventListener("touchmove", this.onMouseEnterHandler);
      element.removeEventListener("touchend", this.onMouseLeaveHandler);
    });

    gsap.to(this.cursor, 0.25, { scale: 0, onComplete: () => {
      this.cursor.classList.remove('_link-hover');
      this.cursor.classList.remove('_expand-hover')
      this.active = false;
    }})


  }
}
